<app-modal id="edit-location-modal" #locationModal>
    <div class="app-modal-header">
        {{ editingMode === locationEditingMode.ADD_FEATURE_LOCATION ? 'Add ' : 'Edit ' }}
        {{ editingMode === locationEditingMode.EDIT_SENSOR_LOCATION ? 'sensor' : 'measurement' }} location
    </div>
    <div class="app-modal-body">
        <h6 class="row mx-0 mt-2">
            You can {{ editingMode === locationEditingMode.ADD_FEATURE_LOCATION ? 'add a' : 'edit the ' }}
            {{ editingMode === locationEditingMode.EDIT_SENSOR_LOCATION ? 'sensor' : 'measurement' }} location.
        </h6>
        <form [formGroup]="updateLocationForm" novalidate>
            <div class="form-row row mx-0 mt-2" *ngIf="editingMode !== locationEditingMode.EDIT_SENSOR_LOCATION">
                <span class="font-weight-bold">Type: </span>
                <select id="type-input" class="custom-select rounded-0" formControlName="type">
                    <option *ngFor="let featureTypeName of featureTypeNames">
                        {{ featureTypeName }}
                    </option>
                </select>
            </div>
            <div class="form-row row mx-0 mt-2" *ngIf="editingMode !== locationEditingMode.EDIT_SENSOR_LOCATION">
                <span class="font-weight-bold">Name: </span>
                <input id="feature-name" type="text" class="form-control squared"
                       formControlName="name" [maxlength]="40"/>
                <span *ngIf="updateFeatureController.nameControl.invalid" class="text-danger">
            <span *ngIf="updateFeatureController.nameControl.errors['required']">
              {{ validatorMessage.Required }}
            </span>
          </span>
            </div>
            <div *ngIf="editingMode === locationEditingMode.EDIT_FEATURE_LOCATION || editingMode === locationEditingMode.ADD_FEATURE_LOCATION"
                 class="form-row row mx-0 mt-2">
                <label class="font-weight-bold">Description</label>
                <input id="feature-description" type="text" class="form-control squared"
                       formControlName="description" [maxlength]="254"/>
                <span *ngIf="updateFeatureController.descriptionControl.invalid" class="text-danger">
          <span *ngIf="updateFeatureController.descriptionControl.errors['required']">
            {{ validatorMessage.Required }}
          </span>
        </span>
            </div>

            <div class="form-row row mx-0 mt-2">
                <div class="col-md-4 pl-0">
                    <label>X-position RD</label>
                    <div id="x-position">
                        <input id="x-position-input" type="text" class="form-control squared"
                               formControlName="x" [maxlength]="10" placeholder="E.g. 59315"/>
                    </div>
                    <div id="invalid-x-coordinate" *ngIf="updateFeatureController.xCoordinateControl.invalid" class="text-danger">
                        <div *ngIf="updateFeatureController.xCoordinateControl.errors['required']">
                            {{ validatorMessage.Required }}
                        </div>
                        <div *ngIf="updateFeatureController.xCoordinateControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <label>Y-position RD</label>
                    <div id="y-position">
                        <input id="y-position-input" type="text" class="form-control squared"
                               formControlName="y" [maxlength]="10" placeholder="E.g. 59315"/>
                    </div>
                    <div id="invalid-y-coordinate" *ngIf="updateFeatureController.yCoordinateControl.invalid" class="text-danger">
                        <div *ngIf="updateFeatureController.yCoordinateControl.errors['required']">
                            {{ validatorMessage.Required }}
                        </div>
                        <div *ngIf="updateFeatureController.yCoordinateControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
                <div class="col-md-4 pr-0">
                    <label>Z-position RD</label>
                    <div id="z-position">
                        <input id="z-position-input" type="text" class="form-control squared"
                               formControlName="z" [maxlength]="10" placeholder="E.g. 59315"/>
                    </div>
                    <div id="invalid-z-coordinate" *ngIf="updateFeatureController.zCoordinateControl.invalid" class="text-danger">
                        <div *ngIf="updateFeatureController.zCoordinateControl.errors['pattern']">
                            {{ validatorMessage.Decimal }}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="editingMode === locationEditingMode.EDIT_FEATURE_LOCATION || editingMode === locationEditingMode.ADD_FEATURE_LOCATION"
                 class="form-row row mx-0 mt-2">
                <div class="col-md-6">
                    <label class="font-weight-bold">End Date</label>
                    <br/>
                    <input type="date"
                           class="custom-text-input"
                           id="edit-feature-end-date"
                           formControlName="endDate"
                           [ngClass]="{'placeholder-date': !updateFeatureController.endDateControl.value}"
                    />
                    <div *ngIf="updateFeatureController.endDateControl.invalid" class="text-danger">
                        <div *ngIf="updateFeatureController.endDateControl.errors['invalidEndDate']">
                            {{ validatorMessage.InvalidEndDate }}
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="updateLocationForm.get('type').value == 'Tidal stream'">
                <h6 class="form-row mt-2 pl-1 font-weight-bold">Metadata</h6>
                <div class="form-row">
                    <label class="col-5 mt-1">Distance</label>
                    <input id="distance"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="distance"
                           [required]="true" placeholder="..."/>
                    <span *ngIf="updateFeatureController.distanceControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="updateFeatureController.distanceControl.errors['required']">
              {{ validatorMessage.Required }}
              </span>
              <span *ngIf="updateFeatureController.distanceControl.errors['pattern']">
              {{ validatorMessage.PositiveInteger }}
              </span>
            </span>
          </span>
                </div>
                <div class="form-row">
                    <label class="col-5 mt-1">Minimum Flood Direction (clockwise in degrees)</label>
                    <input id="direction-from"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="directionFrom"
                           placeholder="E.g. 45"
                           [required]="true"/>
                    <span *ngIf="updateFeatureController.directionFromControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="updateFeatureController.directionFromControl.errors['required']">
                {{ validatorMessage.Required }}
              </span>
              <span *ngIf="updateFeatureController.directionFromControl.errors['pattern']">
                {{ validatorMessage.PositiveInteger }}
              </span>
              <span *ngIf="updateFeatureController.directionFromControl.errors['invalidRange']">
                {{ validatorMessage.InvalidRange }}
              </span>
            </span>
          </span>
                </div>
                <div class="form-row">
                    <label class="col-5 mt-1">Maximum Flood Direction (clockwise in degrees)</label>
                    <input id="direction-to"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="directionTo"
                           placeholder="E.g. 320"
                           [required]="true"/>
                    <span *ngIf="updateFeatureController.directionToControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="updateFeatureController.directionToControl.errors['required']">
                {{ validatorMessage.Required }}
              </span>
              <span *ngIf="updateFeatureController.directionToControl.errors['pattern']">
                {{ validatorMessage.PositiveInteger }}
              </span>
              <span *ngIf="updateFeatureController.directionToControl.errors['invalidRange']">
                {{ validatorMessage.InvalidRange }}
              </span>
            </span>
          </span>
                </div>
            </div>
            <div *ngIf="updateLocationForm.get('type').value == 'Height of tide'">
                <h6 class="form-row mt-2 pl-1 font-weight-bold">Metadata</h6>
                <div class="form-row">
                    <label class="col-5 mt-1">NAP to ALAT Conversion (cm)</label>
                    <input id="edit-napToALatConversion"
                           type="text"
                           class="form-control squared col-3 mb-1"
                           formControlName="napToALatConversion"
                           [required]="true"/>
                    <span *ngIf="updateFeatureController.napToALatConversionControl.invalid" class="text-danger col-4 mt-1">
            <span class="float-right">
              <span *ngIf="updateFeatureController.napToALatConversionControl.errors['required']">
              {{ validatorMessage.Required }}
              </span>
              <span *ngIf="updateFeatureController.napToALatConversionControl.errors['pattern']">
              {{ validatorMessage.Decimal }}
              </span>
            </span>
          </span>
                </div>
            </div>
        </form>
    </div>
    <div class="app-modal-footer">
        <div class="row">
            <div class="col-md-6">
                <button type="button" id="close-location-modal" class="btn custom-button-por-blue float-left"
                        (click)="onCancelClick()">CLOSE
                </button>
            </div>
            <div class="col-md-6">
                <button type="button" id="save-and-close-location-modal" class="btn custom-button-por-yellow float-right"
                        [disabled]="isFormInvalid()"
                        (click)="submit()">{{ editingMode === locationEditingMode.ADD_FEATURE_LOCATION ? 'ADD' : 'EDIT' }}
                </button>
            </div>
        </div>
    </div>
</app-modal>
